import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { TransferPanelModule } from 'shared/components/transfer-panel/transfer-panel.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { FileUploadService } from 'common/api/file-upload-service';
import { WrapUpPanelModule } from '../../shared/components/wrapup-panel/wrap-up-panel.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { AlertBoxModule } from 'shared/components/alert-box/alert-box.module';
import { SmartResponsesModule } from '../../shared/components/smart-responses/smart-responses.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ngfModule } from 'angular-file';
import { WorkWidgetControlPanelModule } from 'shared/components/work-widget-control-panel/work-widget-control-panel.module';
import { ChatMessagesQueueService } from 'common/chat-messages-queue/chat-messages-queue.service';
import { TinyMCEEditorModule } from 'shared/components/editor/editor.module';
import { FileUploadPickerModule } from 'shared/components/file-upload-picker/file-upload-picker.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { TextChatActionsModule } from './text-chat-actions/text-chat-actions.module';
import { TextChatButtonsComponent } from './text-chat-buttons/text-chat-buttons.component';
import { TextChatBoxComponent } from './text-chat-box.component';
import { WorkItemWidgetSharedModule } from '../../shared/work-item-widget-shared.module';
import { ChatMessagesModule } from 'shared/components/chat-messages/chat-messages.module';
import { FileUploadBoxModule } from '../../chat-widget/chat-box/file-upload-box/file-upload-box.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    LoadingModule,
    TransferPanelModule,
    VisitorHistoryModule,
    WrapUpPanelModule,
    TooltipModule,
    AlertBoxModule,
    SmartResponsesModule,
    VirtualScrollerModule,
    FormsModule,
    EditorModule,
    ngfModule,
    WorkWidgetControlPanelModule,
    TinyMCEEditorModule,
    FileUploadPickerModule,
    AutoSaveModule,
    TextChatActionsModule,
    WorkItemWidgetSharedModule,
    ChatMessagesModule,
    FileUploadBoxModule
  ],
  providers: [
    FileUploadService,
    ChatMessagesQueueService
  ],
  declarations: [
    TextChatButtonsComponent,
    TextChatBoxComponent
  ],
  exports: [
    TextChatBoxComponent
  ]
})
export class TextChatBoxModule {}
